import React from "react";
import Navbar from "./components/navbar/Navbar";
import About from "./components/about/About";
import Skills from "./components/skills/Skills";
import Projects from "./components/projects/Projects";
import ProfessionalProjects from "./components/professionalProjects/ProfessionalProjects";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import Experience from "./components/experience/Experience";
import Certificates from "./components/certificates/Certificates";
import Contact from "./components/contact/Contact";
import { Toaster } from "react-hot-toast";

export default function App() {
  return (
    <div className="w-full h-auto bg-bodyColor text-lightText pl-5 pr-5">
      <Navbar></Navbar>
      <div className="md:max-w-screen-2xl mx-auto md:px-16">
        <About></About>
        <ProfessionalProjects></ProfessionalProjects>
        <Projects></Projects>
        <Experience></Experience>
        <Skills></Skills>
        <Certificates></Certificates>
        <Contact></Contact>
      </div>
      <Analytics></Analytics>
      <SpeedInsights></SpeedInsights>
      <Toaster />
    </div>
  );
}
